/**
 * @module @/rules/booking_rules
 * @author lwc
 * @description 订舱部分表单的校验规则.
 * @date 2020年3月19日
 * */

 import i18n from '@/lang'

 const userMaintainFormRules = {
    user_code: [{
        required: true,
        message: "不能为空",
        trigger: ['blur', 'change']
    }],
    user_name_cn: [{
        required: true,
        message: "不能为空",
        trigger: ['blur', 'change']
    }],
    user_type: [{
        required: true,
        message: "不能为空",
        trigger: ['blur', 'change']
    }],
    sex: [{
        required: true,
        message: "不能为空",
        trigger: ['blur', 'change']
    }],
    email: [{
        required: true,
        message: "不能为空",
        trigger: ['blur', 'change']
    }],
    dataPermission: [{
        required: true,
        message: "不能为空",
        trigger: ['blur', 'change']
    }],
    identity_card_no: [{
        required: true,
        message: "不能为空",
        trigger: ['blur', 'change']
    }]
 }
 
export {
   userMaintainFormRules
}
 